import React from 'react';
import styled from 'styled-components';
import { Provider } from 'react-redux';
import { Alert } from '@deerplusofficial/pos-components';
import _ from 'lodash';
import configuredStore from '../../store';
import ScannerSelectorButton, { types } from './ScannerSelectorButton';

export { types as scannerTypes };

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
`;

class ScannerSelector extends React.PureComponent {
  render() {
    return (
      <Provider store={configuredStore}>
        <Wrapper>
          {_.map(types, ({ type, name, icon }) => (
            <ScannerSelectorButton
              onClick={Alert.clickCancel}
              key={type}
              type={type}
              icon={icon}
              title={name}
            />
          ))}
        </Wrapper>
      </Provider>
    );
  }
}

export default ScannerSelector;



// WEBPACK FOOTER //
// ./src/components/ScannerSelector/ScannerSelector.js